export default function Divider({ className = "border-t border-gray-300", style }) {
  return <hr className={className} style={style} />;
}